import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";

import { CoreModule } from "@app/core.module";
import { SharedModule } from "@shared/shared.module";

import { AppComponent } from "./app.component";
import { AppRoutingModule } from "./app-routing.module";

import { HomepageLayoutComponent } from "./layout/homepage-layout/homepage-layout.component";
import { DashboardLayoutComponent } from "./layout/dashboard-layout/dashboard-layout.component";
import { QuickquoteLayoutComponent } from "./layout/quickquote-layout/quickquote-layout.component";
import { HeaderComponent } from "./layout/header/header.component";
import { FooterComponent } from "./layout/footer/footer.component";

import { AuthModule } from "@modules/auth/auth.module";
import { AuthLayoutComponent } from "./layout/auth-layout/auth-layout.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { RecaptchaModule } from "ng-recaptcha";
import {
  NbThemeModule,
  NbActionsModule,
  NbLayoutModule,
  NbButtonModule,
  NbMenuModule,
  NbUserModule,
  NbContextMenuModule,
  NbSidebarModule,
  NbIconModule,
  NbStepperModule,
  NbCardModule,
  NbCheckboxModule,
  NbDatepickerModule,
  NbInputModule,
  NbRadioModule,
  NbSelectModule,
  NbToggleModule,
  NbAlertModule,
  NbRouteTabsetModule,
  NbDialogModule
} from "@nebular/theme";
import { NbEvaIconsModule } from "@nebular/eva-icons";
import { MessageModule } from "@modules/messages/message.module";
import { UserProfileComponent } from "./layout/user-profile/user-profile.component";
import { ServicingLayoutComponent } from "./layout/servicing-layout/servicing-layout.component";
import { NoAuthHeaderComponent } from "./layout/no-auth-header/no-auth-header.component";
import { NoAuthFooterComponent } from "./layout/no-auth-footer/no-auth-footer.component";
import { CorrespondenceLayoutComponent } from "./layout/correspondence-layout/correspondence-layout.component";
import { CorrespondenceHeaderComponent } from "./layout/correspondence-header/correspondence-header.component";
import { CorrespondenceFooterComponent } from "./layout/correspondence-footer/correspondence-footer.component";
import { HttpClientModule } from "@angular/common/http";
import { CompanyLayoutComponent } from "./layout/company-layout/company-layout.component";
import { CompanyFooterComponent } from "./layout/company-footer/company-footer.component";
import { CompanyHeaderComponent } from "./layout/company-header/company-header.component";
import { LoanApplicationLayoutComponent } from "./layout/loan-application-layout/loan-application-layout.component";
import { LoanApplicationHeaderComponent } from "./layout/loan-application-header/loan-application-header.component";
import { EffectsModule } from "@ngrx/effects";
import { StoreModule } from "@ngrx/store";
import { LoanApplicationEffects } from "../store/loanapplication.effects";
import { loanApplicationReducer } from "../store/loanapplication.reducer";
import { SalesLayoutComponent } from './layout/sales-layout/sales-layout.component';
import { SalesHeaderComponent } from './layout/sales-header/sales-header.component';
import { SalesFooterComponent } from './layout/sales-footer/sales-footer.component';


@NgModule({
  declarations: [
    AppComponent,
    DashboardLayoutComponent,
    QuickquoteLayoutComponent,
    HomepageLayoutComponent,
    HeaderComponent,
    FooterComponent,
    AuthLayoutComponent,
    UserProfileComponent,
    ServicingLayoutComponent,
    NoAuthHeaderComponent,
    NoAuthFooterComponent,
    CorrespondenceLayoutComponent,
    CorrespondenceHeaderComponent,
    CorrespondenceFooterComponent,
    CompanyLayoutComponent,
    CompanyFooterComponent,
    CompanyHeaderComponent,
    LoanApplicationLayoutComponent,
    LoanApplicationHeaderComponent,
    SalesLayoutComponent,
    SalesHeaderComponent,
    SalesFooterComponent,

  ],
  imports: [
    // angular
    BrowserModule,
    HttpClientModule,

    // 3rd party
    NbLayoutModule,
    NbMenuModule.forRoot(),
    NbThemeModule.forRoot(),
    NbSidebarModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbActionsModule,
    NbUserModule,
    NbContextMenuModule,
    NbEvaIconsModule,
    NbIconModule,
    NbCardModule,
    NbStepperModule,
    NbInputModule,
    NbSelectModule,
    NbDatepickerModule,
    NbRadioModule,
    NbAlertModule,
    NbCheckboxModule,
    NbButtonModule,
    NbToggleModule,
    NbRouteTabsetModule,
    NbDialogModule.forRoot(),
    RecaptchaModule,

    // core & shared
    CoreModule,
    SharedModule,

    // app
    AuthModule,
    AppRoutingModule,

    BrowserAnimationsModule,
    MessageModule,
    EffectsModule.forRoot([LoanApplicationEffects]),
    StoreModule.forRoot(
      {
        loanApplication: loanApplicationReducer
      },
      {}
    )
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule {}
